import React from 'react';
import withIcon from '../utilities/withIcon';

const IconWorkgroup = () => {
  return (
    <g>
      <path d="M8.25 0a2.75 2.75 0 0 1 2.716 3.186 6.747 6.747 0 0 1 3.77 6.5 2.75 2.75 0 0 1-2.543 4.854A6.716 6.716 0 0 1 8 16a6.721 6.721 0 0 1-4.195-1.461 2.75 2.75 0 0 1-2.54-4.854A6.752 6.752 0 0 1 5.51 2.974 2.75 2.75 0 0 1 8.25 0zM6.036 4.382l-.024.009A5.248 5.248 0 0 0 2.75 9.25a2.75 2.75 0 0 1 2.262 4.315A5.21 5.21 0 0 0 8 14.5a5.226 5.226 0 0 0 2.99-.934 2.75 2.75 0 0 1 2.092-4.31l.168-.006a5.25 5.25 0 0 0-2.918-4.705 2.746 2.746 0 0 1-4.296-.163zM2.75 10.75a1.25 1.25 0 1 0 0 2.5 1.25 1.25 0 0 0 0-2.5zm10.5 0a1.25 1.25 0 1 0 0 2.5 1.25 1.25 0 0 0 0-2.5zm-5-9.25a1.25 1.25 0 1 0 0 2.5 1.25 1.25 0 0 0 0-2.5z" />
    </g>
  );
};

export default withIcon(IconWorkgroup);
